import {provideState, provideStore} from '@ngrx/store';
import {provideRouterStore, routerReducer} from '@ngrx/router-store';
import {provideEffects} from '@ngrx/effects';
import {provideStoreDevtools} from '@ngrx/store-devtools';
import {isDevMode} from '@angular/core';
import {appFeature} from './app/app.reducers';
import * as AppLayoutEffects from './app/app-layout.effects';
import {adAccountsFeature} from '../../features/ad-accounts/store/ad-accounts.reducers';

export function provideAppStore() {
	return [
		provideStore(),
		provideState(appFeature.name, appFeature.reducer),
		provideState('router', routerReducer),
		provideState(adAccountsFeature.name, adAccountsFeature.reducer),

		provideEffects([
			AppLayoutEffects
		]),

		provideRouterStore(),
		provideStoreDevtools({
			maxAge: 25, // Retains last 25 states
			logOnly: !isDevMode(), // Restrict extension to log-only mode
			autoPause: true, // Pauses recording actions and state changes when the extension window is not open
			trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
			traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
		}),
	];
	
}
